import React, { useState, useEffect } from "react";
import { TextField, Button, Typography, Paper, CircularProgress, Link } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import ToastService from "@/service/toaster.service"; // Assuming you have a ToastService
import vendorAuthService from "@/service/auth.service/vendor.auth.service"; // Assuming you have vendor auth service

function ResetPasswordOtp() {
  const [otp, setOtp] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [canResend, setCanResend] = useState(true);
  const [countdown, setCountdown] = useState(30); // Countdown for Resend OTP
  const [successMessage, setSuccessMessage] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  // Retrieve email from location state or localStorage
  useEffect(() => {
    const storedEmail = localStorage.getItem("email");
    if (location.state && location.state.email) {
      const emailFromState = location.state.email;
      setEmail(emailFromState);
      localStorage.setItem("email", emailFromState); // Store the email in localStorage
    } else if (storedEmail) {
      setEmail(storedEmail); // If email is in localStorage, use it
    }
  }, [location]);

  useEffect(() => {
    if (!canResend) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(timer);
            setCanResend(true);
          }
          return prev - 1;
        });
      }, 1000);
    }
  }, [canResend]);

  const handleOtpChange = (e) => {
    const input = e.target.value;
    
    // Allow only digits and limit to 5 characters
    if (/^\d{0,5}$/.test(input)) {
      setOtp(input);
      setError('');
    } else {
      setError('OTP must be a 5-digit number');
    }
  };
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");

    // Validate OTP length (should be exactly 5 digits)
    if (otp.length !== 5 || isNaN(otp)) {
      setError("OTP should be a 5-digit number.");
      return;
    }

    try {
      setLoading(true);
      const response = await vendorAuthService.verifyResetPasswordOtp(email, otp );

      if (response?.status === true) {
        setSuccessMessage("OTP verified successfully. You can now reset your password.");
        navigate("/vendor/auth/reset-password", { state: { email } }); // Redirect to reset password page
      } else {
        setError(response?.data?.error || "Invalid OTP, please try again.");
      }
    } catch (error) {
      ToastService.error(error?.response?.data?.data?.error || "Something went wrong. Please try again.");  
      setError(error?.response?.data?.data?.error || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp= async (e) => {
    e.preventDefault();
    setError("");

    try {
      setLoading(true);
      const response = await vendorAuthService.sendForgetPasswordOtp( email);

      if (response?.status === true) {
        ToastService.success("OTP has been resent successfully.");
        setCanResend(false);
        setCountdown(30); // Reset the countdown
      } else {
        setError(response?.data?.error || "Failed to resend OTP.");
      }
    } catch (error) {
      setError(error?.response?.data?.data?.error || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper className="inner-card" elevation={5}>
      <Typography variant="h5" color="#5E5ACF" fontWeight="bold">
        Reset Password OTP
      </Typography>

      <Typography className="textField">
        A one-time password has been sent to:{" "}
        <Typography component="span" sx={{ fontWeight: 'bold', color: '#6a00f4', fontSize: '12px' }}>
          {email}
        </Typography>.
      </Typography>

      <form onSubmit={handleOtpSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Enter 5-digit OTP"
          variant="outlined"
          value={otp}
          onChange={handleOtpChange}
          error={!!error}
          helperText={error}
        />
        {successMessage && <Typography color="green" sx={{ fontSize: '0.875rem' }}>{successMessage}</Typography>}
        <Button type="submit" variant="contained" fullWidth className="btn-submit" sx={{ mt: 2, color: "black", fontWeight: 'bold' }}>
          {loading ? <CircularProgress size={24} sx={{ color: 'black' }} /> : "Verify OTP"}
        </Button>
      </form>

      {/* Resend OTP Button */}
      {loading ? (
        <CircularProgress size={24} sx={{ color: 'black', mt: 2 }} />
      ) : (
        <>
          {!canResend ? (
            <Typography variant="body2" color="gray" sx={{ mt: 2 }}>
              You can resend OTP in {countdown} seconds
            </Typography>
          ) : (
            <Typography variant="body2" sx={{ mt: 2 }}>
              <Link
                href="#"
                onClick={handleResendOtp}
                sx={{
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: '#5E5ACF',
                  fontWeight: 'bold',
                }}
              >
                Resend OTP
              </Link>
            </Typography>
          )}
        </>
      )}
    </Paper>
  );
}

export default ResetPasswordOtp;
